import clsx from 'clsx';
import { Zap } from 'lucide-react';
import { QuickReply } from '../../lib/quick-replies';

/**
 * Lista das respostas rápidas acima do compositor (aberta pelo "/"). Teclado: setas escolhem,
 * Enter ou Tab inserem, Esc fecha (tratado no compositor); o mouse também escolhe.
 */
export function QuickReplyMenu({
  items,
  index,
  query,
  hasAny,
  onPick,
  onHover,
}: {
  items: QuickReply[];
  index: number;
  query: string;
  /** Existe alguma resposta cadastrada visível para este atendimento. */
  hasAny: boolean;
  onPick: (reply: QuickReply) => void;
  onHover: (index: number) => void;
}) {
  return (
    <div className="absolute right-0 bottom-full left-0 z-30 mb-1 max-h-72 overflow-y-auto rounded-md border border-border bg-panel py-1 text-sm shadow-lg" role="listbox">
      <div className="flex items-center gap-1.5 px-3 pt-1 pb-1.5 text-[11px] text-fg-soft">
        <Zap className="size-3" /> Respostas rápidas · ↑↓ escolhe, Enter insere, Esc fecha
      </div>
      {items.length === 0 && (
        <div className="px-3 py-2 text-xs text-fg-soft">
          {hasAny ? `Nenhuma resposta para /${query}.` : 'Nenhuma resposta rápida cadastrada (Administração → Respostas rápidas).'}
        </div>
      )}
      {items.map((r, i) => (
        <button
          key={r.id}
          type="button"
          role="option"
          aria-selected={i === index}
          // mousedown: escolhe antes de o campo perder o foco.
          onMouseDown={(e) => {
            e.preventDefault();
            onPick(r);
          }}
          onMouseEnter={() => onHover(i)}
          className={clsx('block w-full px-3 py-1.5 text-left', i === index ? 'bg-accent/10' : 'hover:bg-muted')}
        >
          <div className="flex items-baseline gap-2">
            <span className="font-mono text-xs text-accent">/{r.shortcut}</span>
            <span className="truncate font-medium">{r.title}</span>
          </div>
          <div className="truncate text-xs text-fg-soft">{r.body.replace(/\s+/g, ' ')}</div>
        </button>
      ))}
    </div>
  );
}
